type SfxName = 'hold' | 'drag' | 'drop' | 'resize'

const SOURCES: Record<SfxName, string> = {
  hold: '/sfx/hold.mp3',
  drag: '/sfx/drag.mp3',
  drop: '/sfx/drop.mp3',
  resize: '/sfx/resize.mp3',
}

const baseAudio: Partial<Record<SfxName, HTMLAudioElement>> = {}
const lastPlayedAt: Partial<Record<SfxName, number>> = {}

export const DEFAULT_SFX_VOLUME = 0.1

let SFX_VOLUME = DEFAULT_SFX_VOLUME

function getAudio(name: SfxName): HTMLAudioElement {
  const existing = baseAudio[name]
  if (existing) return existing
  const a = new Audio(SOURCES[name])
  a.preload = 'auto'
  a.volume = SFX_VOLUME
  baseAudio[name] = a
  return a
}

function play(name: SfxName, minIntervalMs = 0) {
  const now = performance.now()
  const last = lastPlayedAt[name] ?? 0
  if (minIntervalMs > 0 && now - last < minIntervalMs) return
  lastPlayedAt[name] = now

  const audio = getAudio(name)
  try {
    const shouldClone = !audio.paused && audio.currentTime > 0 && audio.currentTime < audio.duration
    const a = shouldClone ? (audio.cloneNode(true) as HTMLAudioElement) : audio
    a.volume = SFX_VOLUME
    a.currentTime = 0
    void a.play()
  } catch {
    // ignore
  }
}

export const sfx = {
  hold: () => play('hold', 0),
  dragStep: () => play('drag', 0),
  drop: () => play('drop', 0),
  resizeStep: () => play('resize', 0),
  resizeSteps: (steps: number) => {
    const count = Math.max(0, Math.min(12, Math.floor(steps)))
    for (let i = 0; i < count; i += 1) play('resize', 0)
  },
}

export function setSfxVolume(volume: number) {
  SFX_VOLUME = Math.max(0, Math.min(1, volume))
  ;(Object.keys(baseAudio) as SfxName[]).forEach((k) => {
    const a = baseAudio[k]
    if (a) a.volume = SFX_VOLUME
  })
}

export function getSfxVolume() {
  return SFX_VOLUME
}